export const bankDeposit = {
  depositInstructions: "Deposit Instructions",
  depositInstructionsMessageVzla:
    "Register your mobile payment for automatic BDV payments. If you've already paid without registering, use this form.",
  depositInstructionsMessagePlaza:
    "Dear user, to validate your mobile payment and credit it to your virtual wallet, it must be made with the same ID and phone number you used to register your account. If you have another phone number associated with the same ID, simply add it to your mobile payment accounts for the payment to be credited.",
  depositInstructionsImportantMessage: "IMPORTANT: The balance will be updated when you click continue",
  depositInstructionsBank: "Bank",
  depositInstructionsMobilePhone: "Phone",
  depositInstructionsContinue: "Continue",
  depositInstructionsBack: "Back",
  depositInstructionsCancel: "Cancel",
  depositInstructionsCopy: "Copy",
  depositInstructionsCopied: "Copied",
  depositInstructionsError: "There was an error:",
  depositInstructionsOptions: "How would you like to deposit?",
  depositInstructionsBankTitle: "Success!",
  depositInstructionsBankSuccess: "Deposit consolidated with success!",
  depositInstructionsBankWarning: "Attention!",
  depositInstructionsBankError: "No transaction was found",

  depositInstructionsBankOptionsTitle: "Choose your bank",
  depositInstructionsBankOptions: "Select a bank",
  depositInstructionsBankVzlaSelectDate: "Select Date",
  depositInstructionsCreditSoon: "Your deposit will be credited in a few moments",
  depositInstructionsPaymentDone: "I have already made my payment",

  depositInstructionsCancelBtn: "Cancel",
  depositInstructionsCopyBtnTitle: "Press the button to copy",

  // VENEZUELA BANK
  depositInstructionsBankVzlaReference: "Reference",
  depositInstructionsBankVzlaAmount: "Amount",
  depositInstructionsBankVzlaDate: "Date",
  depositInstructionsBankVzlaBank: "Bank",
  depositInstructionsBankVzlaBankOptions: "Select a bank",
  depositInstructionsBankVzlaForm: "Form",
  depositInstructionsBankVzlaFormTitle: "Payment Registration Form",
  depositInstructionsBankVzlaFormInfo: "Use the form if you have already paid.",
  depositInstructionsBankVzlaSupportMessage: "Was your payment not credited automatically?",
  depositInstructionsBankVzlaSupportLink: "Contact our 24/7 support",

  //ZELLE
  depositInstructionsZelleMessage:
    "To deposit with Zelle, send your payment to zelle@randrush.com and message us on WhatsApp with the receipt. We'll process it quickly.",
  depositInstructionsZelleEmail: "E-mail",
  depositInstructionsZelleCopyBtnTitle: "Tap the button to copy the email",
  depositInstructionsSupport: "Contact Support",

  //BINANCE
  depositInstructionsBinanceTitle: "Binance USDT Deposit",
  depositInstructionsBinanceAmount: "Amount",
  depositInstructionsBinanceMinAmount: "Minimum deposit",
  depositInstructionsBinanceCompletePayment: "Complete Your Binance Payment",
  depositInstructionsBinanceOptions: "Choose your preferred payment method below",
  depositInstructionsBinanceOptionsTitle: "Payment Methods",
  depositInstructionsBinanceUseQR: "Scan this QR code with your Binance app",
  depositInstructionsBinanceLink: "Click to open the payment page in Binance",
  depositInstructionsBinanceOpenLink: "Open Binance Payment Link",
  depositInstructionsBinanceStatus: "Transaction Status",
  depositInstructionsBinanceContinue: "Continue",
  depositInstructionsBinanceBack: "Back",
  depositInstructionsBinanceCheckingStatus: "Checking status...",
  depositInstructionsBinancePending: "pending",
  depositInstructionsBinanceEnterAmount: "Enter amount to deposit",
  depositInstructionsBinanceGeneratedLink: "Payment link generated! Choose your preferred payment method.",
  depositInstructionsBinanceError: "Failed to create deposit. Please try again.",
  depositInstructionsBinanceValidAmount: "Please enter a valid amount",
  depositInstructionsBinancePaymentCompleted: "Payment completed successfully!",
  depositInstructionsBinanceScanQR: "Scan QR Code",
  depositInstructionsBinancePaymentLinkTitle: "Payment Link",
  depositInstructionsBinanceOrSeparator: "or",

  //PAYKU
  depositInstructionsPaykuTitle: "Payku CLP Deposit",
  depositInstructionsPaykuDescription: "Make deposits in Chilean Pesos using various payment methods",
  depositInstructionsPaykuAmount: "Amount",
  depositInstructionsPaykuEmail: "Email",
  depositInstructionsPaykuPaymentMethod: "Payment Method",
  depositInstructionsPaykuMinAmount: "Minimum deposit: 1,000 CLP",
  depositInstructionsPaykuEnterAmount: "Enter amount to deposit",
  depositInstructionsPaykuEmailPlaceholder: "your@email.com",
  depositInstructionsPaykuSelectMethod: "Select payment method",
  depositInstructionsPaykuCreatePayment: "Create Payment",
  depositInstructionsPaykuCompletePayment: "Complete Your Payku Payment",
  depositInstructionsPaykuOptions: "Complete your payment in the opened window.",
  depositInstructionsPaykuOpenLink: "Open Payment Link",
  depositInstructionsPaykuStatus: "Payment Status",
  depositInstructionsPaykuCheckingStatus: "Checking status...",
  depositInstructionsPaykuPending: "Pending",
  depositInstructionsPaykuapproved: "Approved",
  depositInstructionsPaykucompleted: "Completed",
  depositInstructionsPaykurejected: "Rejected",
  depositInstructionsPaykuexpired: "Expired",
  depositInstructionsPaykuInstructions: "You will be redirected back once payment is processed.",
  depositInstructionsPaykuError: "Failed to create payment. Please try again.",
  depositInstructionsPaykuValidEmail: "Please enter a valid email address",
  depositInstructionsPaykuPaymentCompleted: "Payment completed successfully!",
  depositInstructionsPaykuPaymentRejected: "Payment was rejected",
  depositInstructionsPaykuPaymentExpired: "Payment expired",
  depositInstructionsPaykuUnsupportedCurrency: "Currency not supported",
  depositInstructionsPaykuOnlyCLP: "Payku is only available for Chilean Pesos (CLP)",
  depositInstructionsPaykuAllMethods: "All Methods",
  depositInstructionsPaykuAllMethodsDescription: "Recommended - All available methods",
  depositInstructionsPaykuWebpayDescription: "Most common payment method",
  depositInstructionsPaykuWebpayPlus1_3: "Webpay plus (1-3 installments)",
  depositInstructionsPaykuWebpayPlus4_6: "Webpay plus (4-6 installments)",
  depositInstructionsPaykuWebpayPlus7_12: "Webpay plus (7-12 installments)",
  depositInstructionsPaykuWebpayPlusDesc: "Credit option",

  // PAYKU WITHDRAWAL
  withdrawalPaykuTitle: "Payku CLP Withdrawal",
  withdrawalPaykuAvailableBalance: "Available Balance",
  withdrawalPaykuAmount: "Amount",
  withdrawalPaykuBeneficiaryName: "Beneficiary Name",
  withdrawalPaykuEmail: "Email",
  withdrawalPaykuPhone: "Phone",
  withdrawalPaykuRUT: "Chilean RUT",
  withdrawalPaykuBank: "Bank",
  withdrawalPaykuAccountType: "Account Type",
  withdrawalPaykuAccountNumber: "Account Number",
  withdrawalPaykuMinAmount: "Minimum withdrawal: 5,000 CLP",
  withdrawalPaykuSuccessTitle: "Withdrawal request submitted!",
  withdrawalPaykuSuccessMessage:
    "Your withdrawal request was created successfully. The funds will be processed to your bank account within the next few hours.",
  withdrawalPaykuSuccessAmountLabel: "Requested amount",
  withdrawalPaykuSuccessBankLabel: "Destination bank",
  withdrawalPaykuSuccessClose: "Got it",
  withdrawalPaykuEnterAmount: "Enter amount to withdraw",
  withdrawalPaykuBeneficiaryNamePlaceholder: "Full name of account holder",
  withdrawalPaykuEmailPlaceholder: "your@email.com",
  withdrawalPaykuPhonePlaceholder: "+56912345678",
  withdrawalPaykuRUTPlaceholder: "12345678-9",
  withdrawalPaykuRUTFormat: "Format: 12345678-9",
  withdrawalPaykuSelectBank: "Select bank",
  withdrawalPaykuAccountNumberPlaceholder: "Account number",
  withdrawalPaykuSubmit: "Submit Withdrawal",
  withdrawalPaykuSuccess: "Withdrawal request submitted successfully!",
  withdrawalPaykuError: "Failed to submit withdrawal. Please try again.",
  withdrawalPaykuInsufficientBalance: "Insufficient balance",
  withdrawalPaykuBeneficiaryNameRequired: "Beneficiary name is required",
  withdrawalPaykuValidEmail: "Please enter a valid email address",
  withdrawalPaykuPhoneRequired: "Phone number is required",
  withdrawalPaykuValidRUT: "Please enter a valid Chilean RUT (format: 12345678-9)",
  withdrawalPaykuBankRequired: "Please select a bank",
  withdrawalPaykuAccountNumberRequired: "Account number is required",
  withdrawalPaykuUnsupportedCurrency: "Currency not supported",
  withdrawalPaykuRegisterRUTTitle: "Register your Chilean RUT",
  withdrawalPaykuRegisterRUTDescription:
    "To withdraw via Payku we need your RUT. It can only be registered once and every future withdrawal will use this same RUT.",
  withdrawalPaykuRegisterRUTSubmit: "Register RUT",
  withdrawalPaykuRegisterRUTWarning:
    "Important: Once registered, this RUT cannot be changed and you'll only be able to withdraw to bank accounts linked to it.",
  withdrawalPaykuRUTRegistrationWarning: "You can only register your RUT once. Make sure it's correct.",
  withdrawalPaykuRUTRegistrationError: "Couldn't register the RUT. Please try again.",
  withdrawalPaykuRUTLockedHint: "Withdrawals are only allowed to bank accounts linked to this RUT.",
  withdrawalPaykuCreateAccountTitle: "Add Chilean bank account",
  withdrawalPaykuCreateAccountSubmit: "Save account",
  withdrawalPaykuBankAccountRequiredFields: "Bank, account number and account holder name are required.",
  withdrawalPaykuBankAccountCreateError: "Couldn't create the bank account. Please try again.",
  withdrawalPaykuSelectAccount: "Select a bank account",
  withdrawalPaykuSelectAccountRequired: "You must select a bank account.",
  withdrawalPaykuAddNewAccount: "Add new account",
  withdrawalPaykuDeleteAccount: "Delete account",
  withdrawalPaykuOnlyCLP: "Payku withdrawals are only available for Chilean Pesos (CLP)",

  // PAYKU CALLBACK PAGE
  paykuCallbackVerifying: "Verifying Payment",
  paykuCallbackVerifyingMessage: "Please wait while we verify your transaction status...",
  paykuCallbackSuccess: "Payment Successful!",
  paykuCallbackSuccessMessage:
    "Your deposit has been processed successfully. The balance has been credited to your account.",
  paykuCallbackFailed: "Payment Failed",
  paykuCallbackFailedMessage: "Sorry, your payment could not be processed. Please try again or contact support.",
  paykuCallbackPending: "Payment Pending",
  paykuCallbackPendingMessage: "Your payment is being processed. You will receive a notification when it's complete.",
  paykuCallbackOrderId: "Order ID",
  paykuCallbackAmount: "Amount",
  paykuCallbackRedirectMessage: "You will be redirected to the home page in {{seconds}} seconds...",
  paykuCallbackGoHome: "Go to Home",

  // Ubii pago orphan claim
  depositListRif: "RIF",
  ubiiPagoClaimTitle: "Ubii Pago Deposit",
  ubiiPagoClaimBanksHint: "Pay from Ubii App with your prepaid balance.",
  ubiiPagoClaimStepsTitle: "Pay with Ubii App",
  ubiiPagoClaimStep1: "Select a bank below and copy the recipient details (tax ID, bank, and phone).",
  ubiiPagoClaimStep2: "Open Ubii App, sign in, and choose Transfer or Mobile Payment.",
  ubiiPagoClaimStep3: "In Ubii App, enter the details you copied and confirm the transfer.",
  ubiiPagoClaimStep4: "Note the amount and the last 6 digits of your reference number.",
  ubiiPagoClaimStep5: "Tap the “I already deposited” button.",
  ubiiPagoClaimPaidCta: "I already deposited",
  ubiiPagoClaimBack: "Back",
  ubiiPagoClaimReportTitle: "Report payment",
  ubiiPagoClaimReportHint: "Enter the amount and only the last 6 digits of the reference from your receipt.",
  ubiiPagoClaimAmountLabel: "Amount",
  ubiiPagoClaimAmountInvalid: "Enter a valid amount greater than 0.",
  ubiiPagoClaimAmountDecimalHint: "You can use a comma or a dot; it displays with a comma (e.g. 100,50).",
  ubiiPagoClaimReferenceLabel: "Last 6 digits of the reference",
  ubiiPagoClaimReferencePlaceholder: "123456",
  ubiiPagoClaimReferenceHint: "Don't enter the full reference: only the last 6 digits from your receipt.",
  ubiiPagoClaimReferenceInvalid: "Enter exactly the last 6 digits of the reference.",
  ubiiPagoClaimSubmit: "Report payment",
  ubiiPagoClaimClose: "Close",
  ubiiPagoClaimAttemptsInfo: "Maximum {{max}} attempts. If you run out, wait 10 minutes.",
  ubiiPagoClaimAttemptsCount: "Attempts: {{current}}/{{max}}",
  ubiiPagoClaimCooldownHint: "You can try again when the countdown ends.",
  ubiiPagoClaimSuccessToast: "Deposit credited",
  ubiiPagoClaimSuccessTitle: "Deposit credited",
  ubiiPagoClaimSuccessMessage: "Your balance is ready to play.",
  ubiiPagoClaimNewBalanceLabel: "New balance",
  ubiiPagoClaimErrorInvalid: "Please enter a valid amount and reference number.",
  ubiiPagoClaimErrorNotFound:
    "We couldn't find a matching payment. Double-check the amount and reference number, or wait a few minutes if you just sent it and try again.",
  ubiiPagoClaimErrorManualReview: "This needs manual review. Please contact support with your payment reference.",
  ubiiPagoClaimErrorRateLimit: "You reached the limit of 10 attempts. Wait 10 minutes and try again.",
  ubiiPagoClaimErrorGeneric: "Something went wrong. Please try again in a moment, or contact support.",
};
